import Img1 from "./cardImg/education.jpeg";
import Img2 from "./cardImg/health1.jpeg";
import Img3 from "./cardImg/finace1.jpeg";
import Img4 from "./cardImg/ecom1.jpeg";
import Img5 from "./cardImg/retail1.jpeg";
import Img6 from "./cardImg/travel1.jpeg";
import Img7 from "./cardImg/hospital1.jpeg";
import Img8 from "./cardImg/logistics.jpeg";
import Img9 from "./cardImg/realEstate.jpeg";
import Img10 from "./cardImg/insurace.jpeg";
import Img11 from "./cardImg/enterm.jpeg";
import Img12 from "./cardImg/govt.jpeg";

const cardData = [
  {
    card_id: 1,
    title: "Education & Edtech 🎓",
    description: "Streamline course inquiries, registrations and assignment sharing, while delivering real-time updates and personalized learning experiences - all within chat. ",
    img: Img1,
    badge: "New",
  },
  {
    card_id: 2,
    title: "Healthcare 🏥",
    description:
      "Simplify appointment bookings, medical inquiries, report access and prescription refills by providing a personalized experience for both patients and healthcare providers.",
    img: Img2,
    badge: "New",
  },
  {
    card_id: 3,
    title: "Finance 💰",
    description:
      "Transform financial services with instant balance checks, secure transactions, loan assistance and payments, all through a smart chatbot.",
    img: Img3,
    badge: "New",
  },
  {
    card_id: 4,
    title: "E-commerce 🛍️",
    description:
      "Enhance customer experiences with product catalogs, interactive messages, quick replies, broadcast templates and automated order tracking through AI chatbot integration.",
    img: Img4,
    badge: "New",
  },
  {
    card_id: 5,
    title: "Retail 🛒",
    description:
      "Enhance in-store shopping with quick browsing, real-time inventory updates, personalized offers and easy checkout via WhatsApp.",
    img: Img5,
    badge: "Premium",
  },
  {
    card_id: 6,
    title: "Travel & Tourism ✈️",
    description:
      "WhatsApp makes travel bookings, updates and inquiries seamless, offering customers a simple, real-time messaging experience.",
    img: Img6,
    badge: "Premium",
  },
  {
    card_id: 7,
    title: "Hospitality 🏨",
    description:
      "Simplify bookings, guest interactions, service requests, feedbacks, offering a seamless and personalized experience for both customers and hotels.",
    img: Img7,
    badge: "Premium",
  },
  {
    card_id: 8,
    title: "Logistics 🚚",
    description:
      "Simplify order tracking, shipment update and customer support, providing real-time, efficient communication for both businesses and their clients.",
    img: Img8,
    badge: "Premium",
  },
  {
    card_id: 9,
    title: "Real Estate 🏠",
    description:
      "Manage property inquiries, schedule viewings and share listings, offering a smooth, responsive experience for both agents and potential buyers.",
    img: Img9,
    badge: "Upcoming",
  },
  {
    card_id: 10,
    title: "Insurance 🛡️",
    description:
      "Enable instant policy inquiries, claims and secure premium payments, all through a seamless and personalized chat experience.",
    img: Img10,
    badge: "Upcoming",
  },
  {
    card_id: 11,
    title: "Event Management 🎥",
    description:
      "Streamline event registrations, send personalized reminders, share event details and manage attendee, ensuring engaging experience for both organizers and participants.",
    img: Img11,
    badge: "Upcoming",
  },
  {
    card_id: 12,
    title: "Government Services 🏛️",
    description:
      "Simplify citizen interactions with real-time updates, service requests, document submissions, payment collection, offering a fast and transparent experience.",
    img: Img12,
    badge: "Upcoming",
  },
];

export default cardData;
